import { InlineText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';

export const ServiceNotSupportedError = () => {
  return (
    <ErrorWrapper>
      <InlineText2 textAlign="center">Аукцион не доступен для выбранной услуги размещения</InlineText2>
    </ErrorWrapper>
  );
};
